import { Tag } from "lucide-react";

import {
  createConfigurationLucideIcon,
  createNavigationLucideIcon,
} from "./createNavigationLucideIcon";

export const ProductsIcon = createNavigationLucideIcon(Tag);
export const ConfigurationProductsIcon = createConfigurationLucideIcon(Tag);
